import React from "react";
import { Container } from "@sainsburys-tech/luna-grid";
import { Link } from "@sainsburys-tech/luna-link";

import {
  Notification,
  NotificationStatuses,
} from "@jsainsburyplc/id-ui-common";

const NotificationPage = ({
  title,
  warningInfo,
  warningInfoLink,
  warningInfoLinkLabel,
  info,
  action = null,
  children,
  type = NotificationStatuses.WARNING_TYPE,
}) => (
  <Container soft size="xs">
    <div className="c-hero c-hero--center">
      <h3>{title}</h3>
    </div>
    <div className="ln-u-soft ln-u-text-align-center">
      <Notification type={type}>
        <span className="ln-u-font-weight-bold">
          {warningInfo}{" "}
          {warningInfoLinkLabel && (
            <Link
              id="warning-link"
              className="ln-c-link ln-c-link--bare ln-c-link--cta ln-c-link--alpha"
              href={warningInfoLink}
            >
              {warningInfoLinkLabel}
            </Link>
          )}
        </span>
        <br />
        {info && <div test-id="info">{info}</div>}
      </Notification>
      <br />
      {action}
      {children && <div>{children}</div>}
    </div>
  </Container>
);

export default NotificationPage;
